export default __webpack_public_path__ + "static/media/client-04.b3f74e69.webp";